if (!window.__relatedProductsInitialized) {
  window.__relatedProductsInitialized = true;

  document.addEventListener("DOMContentLoaded", async () => {
    await initRelatedProductsSections();
    bindRelatedProductsResize();
  });

  function shouldEnableCarousel() {
    return window.innerWidth > 991;
  }

  async function initRelatedProductsSections(scope = document) {
    const sections = scope.querySelectorAll(".related-products");

    for (const section of sections) {
      await assembleRelatedFeed(section);
      initRelatedProductsCarousels(section);
    }
  }

  function slideProductId(slide) {
    const card = slide.querySelector(".js-product-grid-item");
    return card ? card.getAttribute("data-product-id-2") : null;
  }

  function wrapSlide(card) {
    const slide = document.createElement("li");
    slide.className = "splide__slide";
    slide.appendChild(card);
    return slide;
  }

  async function getVendorSlides(section) {
    const source = section.querySelector(".js-vendor-source");
    if (!source) return [];

    // Metafield path: vendor products already rendered server-side.
    const rendered = Array.from(source.querySelectorAll(".splide__slide"));
    if (rendered.length) return rendered;

    // Fallback path: fetch the vendor search results and lift the product cards.
    const loader = source.querySelector(".js-load-vendor-products");
    if (!loader || !loader.dataset.url) return [];

    try {
      const response = await fetch(loader.dataset.url, {
        method: "GET",
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const doc = new DOMParser().parseFromString(await response.text(), "text/html");
      const vendorWrapper = doc.querySelector(".js-search-vendor");
      if (!vendorWrapper) return [];

      return Array.from(vendorWrapper.querySelectorAll(".js-product-grid-item")).map(
        (card) => wrapSlide(card.cloneNode(true))
      );
    } catch (error) {
      console.error("Vendor products load error:", error);
      return [];
    }
  }

  function getBestSellerSlides(section) {
    const source = section.querySelector(".js-bestsellers-source");
    if (!source) return [];
    return Array.from(source.querySelectorAll(".splide__slide"));
  }

  // Builds the single carousel by interleaving vendor and best-seller pools 1:1,
  // stopping when either pool runs out. If one pool is empty, the other shows alone.
  async function assembleRelatedFeed(section) {
    const carousel = section.querySelector(".js-related-products-carousel");
    if (!carousel) return;

    const list = carousel.querySelector(".splide__list");
    if (!list || list.dataset.assembled === "true") return;

    const currentId = section.dataset.currentProductId;

    let vendorSlides = await getVendorSlides(section);
    let bestSlides = getBestSellerSlides(section);

    const notCurrent = (slide) => {
      const id = slideProductId(slide);
      return id && id !== currentId;
    };
    vendorSlides = vendorSlides.filter(notCurrent);
    bestSlides = bestSlides.filter(notCurrent);

    // De-dupe best sellers against products already present in the vendor pool.
    const seen = new Set(vendorSlides.map(slideProductId));
    bestSlides = bestSlides.filter((slide) => {
      const id = slideProductId(slide);
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });

    // Interleave 1:1 as far as both pools allow, then top up from whichever pool
    // still has products, capped at the target total. A single non-empty pool
    // (the other being empty) falls out of this naturally as the "remainder".
    const ordered = [];
    const pairs = Math.min(vendorSlides.length, bestSlides.length);
    for (let i = 0; i < pairs; i++) {
      ordered.push(vendorSlides[i], bestSlides[i]);
    }
    const remainder =
      vendorSlides.length > bestSlides.length
        ? vendorSlides.slice(pairs)
        : bestSlides.slice(pairs);
    ordered.push(...remainder);

    const maxProducts = parseInt(section.dataset.maxProducts, 10);
    const finalSlides = maxProducts > 0 ? ordered.slice(0, maxProducts) : ordered;

    list.innerHTML = "";
    finalSlides.forEach((slide) => list.appendChild(slide));
    list.dataset.assembled = "true";

    // Remove the now-consumed hidden source lists.
    section.querySelectorAll(".related-products__source").forEach((el) => el.remove());

    if (typeof initializeObservers === "function") initializeObservers();
    if (typeof window.observeGridItems === "function") window.observeGridItems(list);
    if (typeof ProductGridLazyVariants !== "undefined" && window.innerWidth < 992) {
      ProductGridLazyVariants.updateMobileVisibility();
    }
  }

  function initSingleRelatedCarousel(element) {
    if (!element) return;
    if (element.__splideInstance) return;
    if (!shouldEnableCarousel()) return;

    const slidesCount = element.querySelectorAll(".splide__slide").length;
    if (slidesCount < 1) return;

    const splide = new Splide(element, {
      type: "slide",
      drag: true,
      gap: "16px",
      perPage: 4,
      rewind: false,
      arrows: false,
      pagination: false,
      breakpoints: {
        1440: {
          perPage: 4,
          gap: "16px",
        },
        1298: {
          perPage: 3,
          gap: "16px",
        },
      },
    });

    splide.mount();
    element.__splideInstance = splide;
    if (typeof window.enableSplideWheelNav === "function") {
      window.enableSplideWheelNav(splide, element);
    }
  }

  function initRelatedProductsCarousels(scope = document) {
    scope.querySelectorAll(".js-related-products-carousel").forEach((element) => {
      if (!shouldEnableCarousel()) {
        destroySingleRelatedCarousel(element);
        return;
      }

      if (!element.__splideInstance) {
        initSingleRelatedCarousel(element);
      }
    });
  }

  function destroySingleRelatedCarousel(element) {
    if (element && element.__splideInstance) {
      element.__splideInstance.destroy(true);
      element.__splideInstance = null;
    }
  }

  function destroyRelatedProductsCarousels(scope = document) {
    scope.querySelectorAll(".js-related-products-carousel").forEach((element) => {
      destroySingleRelatedCarousel(element);
    });
  }

  function bindRelatedProductsResize() {
    let resizeTimer;

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        document.querySelectorAll(".related-products").forEach((section) => {
          const carousel = section.querySelector(".js-related-products-carousel");
          if (!carousel) return;

          if (shouldEnableCarousel()) {
            if (!carousel.__splideInstance) {
              initSingleRelatedCarousel(carousel);
            }
          } else {
            destroySingleRelatedCarousel(carousel);
          }
        });
      }, 150);
    });
  }

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", async (event) => {
      const section = event.target;
      destroyRelatedProductsCarousels(section);
      await initRelatedProductsSections(section);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      destroyRelatedProductsCarousels(event.target);
    });

    document.addEventListener("shopify:section:select", async (event) => {
      const section = event.target;
      destroyRelatedProductsCarousels(section);
      await initRelatedProductsSections(section);
    });

    document.addEventListener("shopify:section:deselect", async (event) => {
      const section = event.target;
      destroyRelatedProductsCarousels(section);
      await initRelatedProductsSections(section);
    });
  }
}
